/**
 * LoginPage — autenticazione Phase 5 (IMPL-P5-011).
 *
 * Wraps the login form inside the standard auth chrome. Footer links to
 * the signup page so first-time users can register without re-discovering
 * the URL.
 */
import { Link } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { AuthCard } from '../components/AuthCard';
import { LoginForm } from '../components/LoginForm';

export function LoginPage() {
  return (
    <AuthLayout>
      <AuthCard
        title="Accedi al portale"
        description="Inserisci le tue credenziali per accedere al portale di registrazione contratti."
        footer={
          <p className="text-muted-foreground">
            Non hai un account?{' '}
            <Link
              to="/registrati"
              className="font-medium text-primary underline-offset-4 hover:underline"
            >
              Registrati
            </Link>
          </p>
        }
      >
        <LoginForm />
      </AuthCard>
    </AuthLayout>
  );
}
